/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FilterClinicDoctorDto } from '../../models/filter-clinic-doctor-dto';
import { ResponseClinicDoctorDto } from '../../models/response-clinic-doctor-dto';

export interface ClinicDoctorControllerFilter$Params {
  
    /**
     * The clinic-doctor relationship data to update
     */
    body: FilterClinicDoctorDto
}

export function clinicDoctorControllerFilter(http: HttpClient, rootUrl: string, params: ClinicDoctorControllerFilter$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ResponseClinicDoctorDto>>> {
  const rb = new RequestBuilder(rootUrl, clinicDoctorControllerFilter.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ResponseClinicDoctorDto>>;
    })
  );
}

clinicDoctorControllerFilter.PATH = '/thalea-clinics/clinic-doctors/filter';
